import { URLBuilder } from 'url-builder/url-builder';
import { Link } from 'lib/ui/link';

export class HomepageLink extends Link {
    constructor(options) {
        super({
            href: () => '/',
            label: 'Úvod',
            ...options,
        });
    }
}
